module.exports = __webpack_public_path__ + "static/media/react-movie-logo.5de5919a.svg";